(ns practitest.frontend.kanban.lanes-editor
  (:require
    [practitest.frontend.common-old-fe.i18n :as i18n]
    [practitest.frontend.common-old-fe.rbdnd :as rbdnd]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(defn list-style [dragging-over]
  {:background    (if dragging-over "silver" "lightgray")
   :user-select   "none"
   :transition    "background-color 0.1s ease"
   :display       "flex"
   :overflow      "auto"
   :padding       "8px"
   :height        "300px"
   :border-radius "4px"})

(defn item-style [dragging]
  {:user-select      "none"
   :opacity          (if dragging 0.8 1.0)
   :padding          "16px"
   :margin           "0 8px 0 0"
   :background-color "var(--pt-color-white)"
   :width            "300px"
   :border-radius    "4px"
   :transition       "opacity 0.1s ease"
   :box-shadow       "0 4px 8px 0 var(--pt-color-shadow), 0 6px 20px 0 var(--pt-color-shadow)"})

(defn lane-ui [lane]
  (let [editing (reagent/atom false)
        name (reagent/atom (:name lane))]
    (fn [lane]
      [:div.row
       (if @editing
         [:div.col-xs-12
          [:div.input-group
           [:input.form-control
            {:value     @name
             :on-change #(reset! name (-> % .-target .-value))
             :type      "text"}]
           [:span.input-group-btn
            [:button.btn.btn-default
             {:type     "button"
              :on-click (fn [e]
                          (re-frame/dispatch [:kanban/change-lane-name
                                              (:id lane)
                                              @name])
                          (reset! editing false))
              :title    (i18n/t :save_lane_name)}
             [:i.fa.fa-save.fa-fw]]]]]
         [:<>
          [:div.col-xs-2.float-right
           [:a.float-right {:href     "#"
                            :on-click (fn [e]
                                        (.preventDefault e)
                                        (re-frame/dispatch [:kanban/delete-lane (:id lane)]))
                            :title    (i18n/t :delete_lane_message)}
            [:i.fa.fa-trash.fa-fw]]]
          [:div.col-xs-10
           [:h4.text-center
            @name
            [:a {:href     "#"
                 :on-click (fn [e]
                             (.preventDefault e)
                             (reset! editing true))
                 :title    (i18n/t :edit_lane_name)}
             [:i.fa.fa-pencil.fa-fw]]]]])])))

(defn lanes-editor-ui []
  (let [lanes (re-frame/subscribe [:kanban/lanes])]
    (fn []
      [:div.kanban-lanes-editor
       [rbdnd/drag-drop-context
        {:on-drag-end (fn [_ destination draggable-id]
                        (when destination
                          (re-frame/dispatch [:kanban/move-lane
                                              draggable-id
                                              (:index destination)])))}
        [rbdnd/droppable {:id        "kanban/lane-editor"
                          :direction "horizontal"
                          :style-f   list-style
                          :title     [:h5
                                      (i18n/t :lane_editor)
                                      [:a
                                       {:href     "#"
                                        :on-click (fn [e]
                                                    (.preventDefault e)
                                                    (re-frame/dispatch [:kanban/add-lane]))}
                                       [:i.fa.fa-plus.fa-fw]]]}
         (for [lane @lanes]
           [rbdnd/draggable
            {:id      (str (:id lane))
             :ix      (:position lane)
             :style-f item-style}
            [lane-ui lane]])]]])))
